(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'react-emotion', '../../styles', '../../elements'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('react-emotion'), require('../../styles'), require('../../elements'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.reactEmotion, global.styles, global.elements);
    global.PaginationItem = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _reactEmotion, _styles, _elements) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n        &:not(.isDisabled) {\n          color: ', ';\n        }\n      '], ['\n        &:not(.isDisabled) {\n          color: ', ';\n        }\n      ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    display: flex;\n    font-size: 1rem;\n    width: 1.5rem;\n    height: 1.5rem;\n    border-radius: 50%;\n    cursor: pointer;\n    text-align: center;\n    vertical-align: middle;\n    user-select: none;\n    justify-content: center;\n    align-items: center;\n    &.isActive {\n      border: 1px solid ', ';\n    }\n    &:focus {\n      outline: 0;\n    }\n    &.isDisabled {\n      color: ', ';\n      cursor: default;\n    }\n    &:not(.isActive) {\n      padding: 1px;\n    }\n    &:hover:not(.isDisabled) {\n      background-color: ', ';\n    }\n  '], ['\n    display: flex;\n    font-size: 1rem;\n    width: 1.5rem;\n    height: 1.5rem;\n    border-radius: 50%;\n    cursor: pointer;\n    text-align: center;\n    vertical-align: middle;\n    user-select: none;\n    justify-content: center;\n    align-items: center;\n    &.isActive {\n      border: 1px solid ', ';\n    }\n    &:focus {\n      outline: 0;\n    }\n    &.isDisabled {\n      color: ', ';\n      cursor: default;\n    }\n    &:not(.isActive) {\n      padding: 1px;\n    }\n    &:hover:not(.isDisabled) {\n      background-color: ', ';\n    }\n  ']),
      _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(['\n    font-size: inherit;\n    vertical-align: middle;\n  '], ['\n    font-size: inherit;\n    vertical-align: middle;\n  ']);

  var PaginationItem = function PaginationItem(_ref) {
    var active = _ref.active,
        icon = _ref.icon,
        pageNumber = _ref.pageNumber,
        handlePageChange = _ref.handlePageChange,
        color = _ref.color,
        disabled = _ref.disabled,
        testId = _ref.testId;
    return (
      // Anchor tag makes sense here, as it is being used for navigation
      // eslint-disable-next-line
      _react2.default.createElement(
        'a',
        {
          onClick: handlePageChange,
          onKeyPress: handlePageChange,
          'data-value': pageNumber,
          'data-testid': testId,
          tabIndex: disabled ? -1 : 0,
          'aria-current': active,
          'aria-label': 'Go to Page ' + pageNumber,
          className: (0, _reactEmotion.cx)(classNames.paginationItem, active && 'isActive', disabled && 'isDisabled', (0, _reactEmotion.css)(_templateObject, color))
        },
        icon ? _react2.default.createElement(_elements.MaterialIcon, {
          name: icon,
          color: disabled ? _styles.colors.silver : color,
          className: classNames.materialIcon
        }) : pageNumber
      )
    );
  };

  PaginationItem.defaultProps = {
    icon: null,
    color: _styles.colors.jungle,
    disabled: false,
    active: false
  };

  var classNames = {
    paginationItem: (0, _reactEmotion.css)(_templateObject2, _styles.colors.silver, _styles.colors.silver, _styles.colors.silver),
    materialIcon: (0, _reactEmotion.css)(_templateObject3)
  };

  exports.default = PaginationItem;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Pagination/PaginationItem.js
// module id = 1951
// module chunks = 1